import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Dropdown } from "semantic-ui-react";

export default class DropDown extends PureComponent {
    static propTypes = {
        action: PropTypes.func,
    };

    onDropChange(e, data) {
        this.props.action(this.props.target, data.value);
        if (!!this.props.secondaryAction) {
            this.props.secondaryAction(this.props.target, data.value);
        }
    }

    render() {
        return (
            <div>
                <Dropdown
                    placeholder={this.props.label}
                    selection
                    labeled
                    defaultValue={this.props.defaultValue}
                    options={this.props.options}
                    onChange={this.onDropChange.bind(this)}
                    fluid={this.props.fluid}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/dropdown.js